// main.ts

// import { NotificationService, NotificationType } from './utils/NotificationService';
//import { initNavigation } from './masthead/navigation/init';
//import { adjustMastheadHeight } from './utils/skipLinkFocus';
import { initialisePageScaling } from './utils/scalePage';
import { initialiseBasketListeners } from './basket/eventListeners';
import { handleModalToggling } from './modals/modalListeners';

/**
 * Initializes the application and sets up examples using utility functions and components.
 */
function initializeApp() {
	// setupNotificationExample();
	//initNavigation();

	// Adjust the masthead height dynamically for the skip link
	//adjustMastheadHeight('.hidden__screen-reader', '--masthead-height');

	// Initialise dynamic page scaling
	initialisePageScaling();

	// Basket
	initialiseBasketListeners();

	// Modals
	handleModalToggling();
}

/**
 * Example usage of the NotificationService class.
 */
// function setupNotificationExample() {
// 	// Example: Display a success notification
// 	NotificationService.showNotification(
// 		NotificationType.success,
// 		'Operation Successful',
// 		'The item was added successfully.',
// 	);
//
// 	// Example: Display an error notification
// 	NotificationService.showNotification(
// 		NotificationType.error,
// 		'Operation Failed',
// 		'An error occurred during the operation.',
// 	);
//
// 	// Example: Display an info notification
// 	NotificationService.showNotification(
// 		NotificationType.info,
// 		'Information',
// 		'Here is some important information.',
// 	);
// }

// Initialize the application when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
	initializeApp();
});
